import { render } from "./keyboardShortcuts.vue?vue&type=template&id=2b1f7d9b"
import script from "./keyboardShortcuts.vue?vue&type=script&lang=js"
export * from "./keyboardShortcuts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__